import { Field } from '@smartsoftware/reflex-core';
import { DexResourceModel } from '../abstracts/dexResource.model';

export class OrderComment extends DexResourceModel {

    @Field(String)
    public order_uuid: string | null = '';

    @Field(String)
    public mefOrder_uuid: string | null = '';

    @Field(String)
    public comment: string | null = '';


    constructor(data?: any) {
        super();
        this.mapData(data);
    }

}
